import React, { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import Column from "components/ui/layout/column/column";
import CardBox from "components/ui/controls/card-box/card-box";
import Row from "components/ui/layout/row/row";
import { applyFormat } from "components/ui/ui-helpers";
import "./DetailDepart.css";

const countDecimals = function (value) {
  if (Math.floor(value) === value) return 0;
  var str = value.toString();
  if (str.indexOf(".") !== -1 && str.indexOf("-") !== -1) {
    return str.split("-")[1] || 0;
  } else if (str.indexOf(".") !== -1) {
    return str.split(".")[1].length || 0;
  }
  return str.split("-")[1] || 0;
};

const FormatLignePension = ({ keyId, MiseEnForme, caisse, points, valeurPoint, pensionTheo, coeff, majoEnfant, pension }) => {
  // Fonction pour obtenir l'icône selon le type de cotisation
  const getIconForLibelle = (libelle) => {
    const iconMap = {
      "Pensions brutes": { icon: "💰", color: "#ffffff" },
      "Pensions nettes": { icon: "💰", color: "#ffffff" },
      "Régimes de base": { icon: "RB", color: "#2b58b1ff" },
      "Autres pensions": { icon: "AP", color: "#2b58b1ff" },
      "Régimes complémentaires": { icon: "RC", color: "#2b58b1ff" },
      "Régimes supplémentaires": { icon: "RS", color: "#2b58b1ff" },
      "Régimes facultatifs": { icon: "RF", color: "#2b58b1ff" },
      "Capitaux retraite nets": { icon: "CR", color: "#2b58b1ff" },
    };

    // Cherche une correspondance partielle
    for (const [key, value] of Object.entries(iconMap)) {
      if (libelle.includes(key)) {
        return value;
      }
    }

    // Icône par défaut
    return { icon: "R", color: "#6b7280" };
  };

  const iconData = getIconForLibelle(caisse);

  // Classes spécifiques qui doivent avoir une icône
  const classesAvecIcone = ["detail-pension-brute", "detail-pension-nette", "detail-regime-categorie", "detail-capitaux-retraite-nets"];
  const afficherIcone = classesAvecIcone.includes(MiseEnForme);

  return (
    <div className={`detail-depart-card ${MiseEnForme}`} key={"DetaiDepart" + keyId}>
      <div className="card-column">
        {afficherIcone && (
          <div className="detail-depart-card-icon" style={{ backgroundColor: iconData.color }}>
            {iconData.icon}
          </div>
        )}
        <span style={{ marginLeft: afficherIcone ? "0" : "32px", whiteSpace: "nowrap" }}>{caisse}</span>
      </div>
      {afficherIcone ? (
        <>
          <div className="card-column"></div>
          <div className="card-column"></div>
          <div className="card-column"></div>
          <div className="card-column"></div>
          <div className="card-column"></div>
          <div className="card-column" style={{ minWidth: "130px" }}></div>
        </>
      ) : (
        <>
          <div className="card-column">{points === "-" ? "-" : applyFormat(Math.max(0, points), "ufloat", { thousands: " ", decimal: ",", precision: 2 })}</div>
          <div className="card-column">
            {valeurPoint === "-" ? "-" : applyFormat(Math.max(0, valeurPoint), "ufloat", { thousands: " ", decimal: ",", precision: countDecimals(valeurPoint), unit: " €" })}
          </div>
          <div className="card-column">{pensionTheo === "-" ? "-" : applyFormat(Math.max(0, pensionTheo), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
          <div className="card-column">{coeff === "-" ? "-" : applyFormat(Math.max(0, coeff), "ufloat", { thousands: " ", decimal: ",", precision: caisse==="IRCANTEC"?5:4 })}</div>
          <div className="card-column">{majoEnfant}</div>
          <div className="card-column" style={{ minWidth: "130px" }}>
            {applyFormat(Math.max(0, pension), "uint", { thousands: " ", decimal: ",", unit: " €" })}
          </div>
        </>
      )}
    </div>
  );
};
const FormatLigneTotal = ({ keyId, caisse, pension }) => {
  return (
    <div className={`detail-depart-card`} key={"DetaiDepart" + keyId}>
      <div className="card-column" style={{ color: "#4f46e5", fontWeight: "600" }}>
        <span style={{ marginLeft: "32px", whiteSpace: "nowrap" }}>{caisse}</span>
      </div>
      <div className="card-column"></div>
      <div className="card-column"></div>
      <div className="card-column"></div>
      <div className="card-column"></div>
      <div className="card-column"></div>
      <div className="card-column" style={{ color: "#4f46e5", fontWeight: "600", minWidth: "130px" }}>
        {applyFormat(Math.max(0, pension), "uint", { thousands: " ", decimal: ",", unit: " €" })}
      </div>
    </div>
  );
};
const FormatLigneTotal2 = ({ keyId, caisse, pension }) => {
  return (
    <div className={`detail-depart-card`} key={"DetaiDepart" + keyId} style={{ background: " linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)" }}>
      <div className="card-column"></div>
      <div className="card-column"></div>
      <div className="card-column"></div>
      <div className="card-column"></div>
      <div className="card-column"></div>
      <div className="card-column" style={{ color: "white", fontWeight: "500" }}>
        <span style={{ marginLeft: "32px", whiteSpace: "nowrap" }}>{caisse}</span>
      </div>
      <div className="card-column" style={{ color: "white", fontWeight: "500", minWidth: "130px" }}>
        {applyFormat(Math.max(0, pension), "uint", { thousands: " ", decimal: ",", unit: " €" })}
      </div>
    </div>
  );
};

//   return (
//     <tr key={"DetaiPension" + keyId}>
//       <td>{caisse}</td>
//       <td className="text-center"></td>
//       <td className="text-center">
//
//       </td>
//       <td className="text-center"></td>
//       <td className="text-center"> </td>
//       <td className="text-center"></td>
//       <td className="text-center"></td>
//     </tr>
//   );
// };

const DetailPension = ({ InfosPension, ClientConjoint }) => {
  const context = useContext(AppContext);

  // Calcul du nombre d'enfants selon leur rattachement
  let nbEnfant = 0;
  if (context.state.TableauEnfant) {
    context.state.TableauEnfant.forEach((enfant) => {
      if (!ClientConjoint || ClientConjoint === "") {
        if (enfant.Rattachement === "commune" || enfant.Rattachement === "client") {
          nbEnfant++;
        }
      } else {
        if (enfant.Rattachement === "commune" || enfant.Rattachement === "conjoint") {
          nbEnfant++;
        }
      }
    });
  }

  let index = 0;
  return (
    <Column fill>
      <CardBox>
        <Column fill>
          <div className="detailpension-header-card">
            <div className="header-content">
              <div className="header-left">
                <div className="header-icon">📊</div>
                <div className="header-title">Détail des pensions à l'âge de {InfosPension?.Infos?.AgeDepartRetraite}</div>
              </div>
              {/* valeur supprimée */}
            </div>
          </div>
          {/* Deuxième card violette pour "Rente brute annuelle" */}
          <div className="detailpension-summary-card">
            <div className="header-content">
              <div className="header-left">
                <div className="header-icon">💰</div>
                <div className="header-title">Rente brute annuelle</div>
              </div>
              <div className="header-value">{applyFormat(Math.max(0, InfosPension?.TotalPensionBrute + InfosPension?.TotalRente), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            </div>
          </div>

          <div className="detailpension-white-card">
            <div className="header-content">
              <div className="header-left">
                <div className="header-title">Régimes de base obligatoires</div>
              </div>
              <div className="header-value">{applyFormat(Math.max(0, InfosPension?.TotalPensionBase), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            </div>
          </div>
          <div className="detailpension-white-card">
            <div className="header-content">
              <div className="header-left">
                <div className="header-title">Régimes complémentaires obligatoires</div>
              </div>
              <div className="header-value">{applyFormat(Math.max(0, InfosPension?.TotalPensionComplementaire), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            </div>
          </div>
          <div className="detailpension-white-card">
            <div className="header-content">
              <div className="header-left">
                <div className="header-title">Régimes supplémentaires obligatoires</div>
              </div>
              <div className="header-value">{applyFormat(Math.max(0, InfosPension?.TotalPensionSupplementaire), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            </div>
          </div>
          <div className="detailpension-white-card">
            <div className="header-content">
              <div className="header-left">
              <div className="header-title">Autres pensions</div>
              </div>
              <div className="header-value">{applyFormat(Math.max(0, InfosPension?.TotalAutresPensionsBrute), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            </div>
          </div>
          <div className="detailpension-white-card">
            <div className="header-content">
              <div className="header-left">
                <div className="header-title">Régimes facultatifs</div>
              </div>
              <div className="header-value">{applyFormat(Math.max(0, InfosPension?.TotalRente), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            </div>
          </div>
          <div className="detailpension-summary-card">
            <div className="header-content">
              <div className="header-left">
                <div className="header-icon">📉</div>
                <div className="header-title">Rente nette de prélèvements sociaux annuelle</div>
              </div>
              <div className="header-value">
                {applyFormat(Math.max(0, InfosPension?.TotalPensionNette + InfosPension?.TotalRenteNette), "uint", { thousands: " ", decimal: ",", unit: " €" })}
              </div>
            </div>
          </div>
          <div className="detailpension-summary-card">
            <div className="header-content">
              <div className="header-left">
                <div className="header-icon">🏦</div>
                <div className="header-title">Epargne nette en capital (PER, Assurance vie, PERP...)</div>
              </div>
              <div className="header-value">{applyFormat(Math.max(0, InfosPension?.TotalCapitalFractionne), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
            </div>
          </div>
          <Row tpad>
            <div className="detail-depart-container">
              <div className="detail-depart-list-container">
                {/* En-tête avec les âges de départ */}
                <div className="detail-depart-header">
                  <div className="header-column">Régimes</div>
                  <div className="header-column">Points</div>
                  <div className="header-column">Valeur du point</div>
                  <div className="header-column">Retraite théorique</div>
                  <div className="header-column">Coefficient</div>
                  <div className="header-column">Majo. enfants</div>
                  <div className="header-column">Retraite brute</div>
                </div>

                <FormatLignePension
                  keyId={index++}
                  caisse={"Régimes de base"}
                  MiseEnForme={"detail-regime-categorie"}
                  points={""}
                  valeurPoint={""}
                  pensionTheo={""}
                  coeff={""}
                  majoEnfant={""}
                  pension={""}
                />
                {InfosPension?.InfosRetraite?.hasOwnProperty("RegimeUnifie") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"Régime général unifié"}
                    MiseEnForme={""}
                    points={"-"}
                    valeurPoint={"-"}
                    pensionTheo={InfosPension?.InfosRetraite["RegimeUnifie"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["RegimeUnifie"]["Coefficient"]}
                    majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                    pension={InfosPension?.InfosRetraite["RegimeUnifie"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Mico") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"Minimum contributif"}
                    MiseEnForme={""}
                    points={"-"}
                    valeurPoint={"-"}
                    pensionTheo={InfosPension?.InfosRetraite["Mico"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["Mico"]["Coefficient"]}
                    majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                    pension={InfosPension?.InfosRetraite["Mico"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Cnavpl") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"CNAVPL"}
                    MiseEnForme={""}
                    points={InfosPension?.InfosRetraite["Cnavpl"]["General"]["TotalPoint"]}
                    valeurPoint={InfosPension?.InfosRetraite["Cnavpl"]["General"]["ValeurPoint"]}
                    pensionTheo={InfosPension?.InfosRetraite["Cnavpl"]["General"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["Cnavpl"]["General"]["Coefficient"]}
                    majoEnfant={InfosPension?.InfosRetraite["Cnavpl"]["General"]["CoeffMajoEnfant"] > 0 ? "10%" : "-"}
                    pension={InfosPension?.InfosRetraite["Cnavpl"]["General"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("FonctionPubliqueBase") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"Fonction publique"}
                    MiseEnForme={""}
                    points={"-"}
                    valeurPoint={"-"}
                    pensionTheo={InfosPension?.InfosRetraite["FonctionPubliqueBase"]["General"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["FonctionPubliqueBase"]["General"]["Coefficient"]}
                    majoEnfant={nbEnfant >= 3 ? InfosPension?.InfosRetraite["FonctionPubliqueBase"]["General"]["CoeffMajoEnfant"] + "%" : "-"}
                    pension={InfosPension?.InfosRetraite["FonctionPubliqueBase"]["General"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Crpcen") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"CRPCEN"}
                    MiseEnForme={""}
                    points={"-"}
                    valeurPoint={"-"}
                    pensionTheo={InfosPension?.InfosRetraite["Crpcen"]["General"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["Crpcen"]["General"]["Coefficient"]}
                    majoEnfant={nbEnfant >= 3 ? InfosPension?.InfosRetraite["Crpcen"]["General"]["CoeffMajoEnfant"] + "%" : "-"}
                    pension={InfosPension?.InfosRetraite["Crpcen"]["General"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Cnbf") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"CNBF"}
                    MiseEnForme={""}
                    points={"-"}
                    valeurPoint={"-"}
                    pensionTheo={InfosPension?.InfosRetraite["Cnbf"]["General"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["Cnbf"]["General"]["Coefficient"]}
                    majoEnfant={InfosPension?.InfosRetraite["Cnbf"]["General"]["CoeffMajoEnfant"] > 0 ? "10%" : "-"}
                    pension={InfosPension?.InfosRetraite["Cnbf"]["General"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Msa") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"MSA forfaitaire"}
                    MiseEnForme={""}
                    points={"-"}
                    valeurPoint={"-"}
                    pensionTheo={InfosPension?.InfosRetraite["Msa"]["General"]["PensionBaseForfaitaireTheorique"]}
                    coeff={InfosPension?.InfosRetraite["Msa"]["General"]["Coefficient"]}
                    majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                    pension={InfosPension?.InfosRetraite["Msa"]["General"]["PensionBaseForfaitaire"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Msa") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"MSA proportionnelle"}
                    MiseEnForme={""}
                    points={InfosPension?.InfosRetraite["Msa"]["General"]["TotalPointProportionnel"]}
                    valeurPoint={InfosPension?.InfosRetraite["Msa"]["General"]["ValeurPointProportionnel"]}
                    pensionTheo={InfosPension?.InfosRetraite["Msa"]["General"]["PensionBaseProportionnelleTheorique"]}
                    coeff={InfosPension?.InfosRetraite["Msa"]["General"]["Coefficient"]}
                    majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                    pension={InfosPension?.InfosRetraite["Msa"]["General"]["PensionBaseProportionnelle"]}
                  />
                )}
                <FormatLigneTotal keyId={index++} caisse={"Total régimes de base"} pension={Math.max(0, InfosPension?.TotalPensionBase)} />
                <FormatLignePension
                  keyId={index++}
                  caisse={"Régimes complémentaires"}
                  MiseEnForme={"detail-regime-categorie"}
                  points={""}
                  valeurPoint={""}
                  pensionTheo={""}
                  coeff={""}
                  majoEnfant={""}
                  pension={""}
                />
                {InfosPension?.InfosRetraite?.hasOwnProperty("Salarie") && (
                  <>
                    {InfosPension?.InfosRetraite["Salarie"]["General"]["TotalAgircArcco"] > 0 && InfosPension?.InfosRetraite["Salarie"]["General"]["CapitalAgircArrco"] === 0 && (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"AGIRC-ARRCO"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Salarie"]["General"]["TotalAgircArcco"]}
                        valeurPoint={InfosPension?.InfosRetraite["Salarie"]["General"]["ValeurPointArrco"]}
                        pensionTheo={InfosPension?.InfosRetraite["Salarie"]["General"]["AgircArrcoPensionTheorique"]}
                        coeff={InfosPension?.InfosRetraite["Salarie"]["General"]["CoeffMino"]}
                        majoEnfant="-"
                        pension={InfosPension?.InfosRetraite["Salarie"]["General"]["AgircArrcoPension"]}
                      />
                    )}
                    {InfosPension.InfosRetraite["Salarie"]["General"]["PointAgircTCAvant2016"] > 0 && InfosPension.InfosRetraite["Salarie"]["General"]["CapitalAgircArrco"] === 0 && (
                      <>
                        {InfosPension.InfosRetraite["Salarie"]["General"]["PensionAgircTCAvant2016"] > 0 ? (
                          <FormatLignePension
                            keyId={index++}
                            caisse={"AGIRC TC"}
                            MiseEnForme={""}
                            points={InfosPension?.InfosRetraite["Salarie"]["General"]["PointAgircTCAvant2016"] * InfosPension?.InfosRetraite["Salarie"]["General"]["CoeffConversion"]}
                            valeurPoint={InfosPension?.InfosRetraite["Salarie"]["General"]["ValeurPointArrco"]}
                            pensionTheo={InfosPension?.InfosRetraite["Salarie"]["General"]["PensionTheoAgircTCAvant2016"]}
                            coeff={InfosPension?.InfosRetraite["Salarie"]["General"]["CoeffMinoTCAvant2016"]}
                            majoEnfant="-"
                            pension={InfosPension?.InfosRetraite["Salarie"]["General"]["PensionAgircTCAvant2016"]}
                          />
                        ) : (
                          ""
                        )}
                      </>
                    )}
                    {InfosPension?.InfosRetraite["Salarie"]["General"]["PointsMajores"] > 0 && InfosPension?.InfosRetraite["Salarie"]["General"]["CapitalAgircArrco"] === 0 && (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"Majo enfant AGIRC-ARRCO"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Salarie"]["General"]["PointsMajores"]}
                        valeurPoint={InfosPension?.InfosRetraite["Salarie"]["General"]["ValeurPointArrco"]}
                        pensionTheo={InfosPension?.InfosRetraite["Salarie"]["General"]["MontantMajoration"]}
                        coeff="-"
                        majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                        pension={InfosPension?.InfosRetraite["Salarie"]["General"]["MontantMajoration"]}
                      />
                    )}
                  </>
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Ircantec") && (
                  <>
                    {InfosPension?.InfosRetraite["Ircantec"]["General"]["CapitalIrcantec"] === 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"IRCANTEC"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Ircantec"]["General"]["TotalPoint"]}
                        valeurPoint={InfosPension?.InfosRetraite["Ircantec"]["General"]["ValeurPoint"]}
                        pensionTheo={InfosPension?.InfosRetraite["Ircantec"]["General"]["PensionTheoriqueIrcantec"]}
                        coeff={InfosPension?.InfosRetraite["Ircantec"]["General"]["Coefficient"]}
                        majoEnfant={
                          InfosPension?.InfosRetraite["Ircantec"]["General"]["PointsMajores"] > 0 ? Math.max(0, Math.min(30, 10 + (nbEnfant - 3) * 5)) + "%" : "-"
                        }
                        pension={InfosPension?.InfosRetraite["Ircantec"]["General"]["Pension"]}
                      />
                    ) : (
                      ""
                    )}
                  </>
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("RsiCommercant") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"RSI Commerçant"}
                    MiseEnForme={""}
                    points={InfosPension?.InfosRetraite["RsiCommercant"]["General"]["PointSaisi"]}
                    valeurPoint={InfosPension?.InfosRetraite["RsiCommercant"]["General"]["ValeurPoint"]}
                    pensionTheo={InfosPension?.InfosRetraite["RsiCommercant"]["General"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["RsiCommercant"]["General"]["Coefficient"]}
                    majoEnfant={"-"}
                    pension={InfosPension?.InfosRetraite["RsiCommercant"]["General"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("RsiArtisan") && (
                  <>
                    {InfosPension?.InfosRetraite["RsiArtisan"]["General"]["PointsAvant79"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"RSI Artisan avant 1979"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["RsiArtisan"]["General"]["PointsAvant79"]}
                        valeurPoint={InfosPension?.InfosRetraite["RsiArtisan"]["General"]["ValeurPointAvant79"]}
                        pensionTheo={InfosPension?.InfosRetraite["RsiArtisan"]["General"]["PensionTheoriqueAvant79"]}
                        coeff={InfosPension?.InfosRetraite["RsiArtisan"]["General"]["Coefficient"]}
                        majoEnfant={"-"}
                        pension={InfosPension?.InfosRetraite["RsiArtisan"]["General"]["PensionAvant79"]}
                      />
                    ) : (
                      ""
                    )}

                    {InfosPension?.InfosRetraite["RsiArtisan"]["General"]["PointsAvant97"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"RSI Artisan avant 1997"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["RsiArtisan"]["General"]["PointsAvant97"]}
                        valeurPoint={InfosPension?.InfosRetraite["RsiArtisan"]["General"]["ValeurPointAvant97"]}
                        pensionTheo={InfosPension?.InfosRetraite["RsiArtisan"]["General"]["PensionTheoriqueAvant97"]}
                        coeff={InfosPension?.InfosRetraite["RsiArtisan"]["General"]["Coefficient"]}
                        majoEnfant={"-"}
                        pension={InfosPension?.InfosRetraite["RsiArtisan"]["General"]["PensionAvant97"]}
                      />
                    ) : (
                      ""
                    )}

                    {InfosPension?.InfosRetraite["RsiArtisan"]["General"]["PointsApres97"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"RSI Artisan entre 1997 et 2012"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["RsiArtisan"]["General"]["PointsApres97"]}
                        valeurPoint={InfosPension?.InfosRetraite["RsiArtisan"]["General"]["ValeurPoint"]}
                        pensionTheo={InfosPension?.InfosRetraite["RsiArtisan"]["General"]["PensionTheoriqueApres1997"]}
                        coeff={InfosPension?.InfosRetraite["RsiArtisan"]["General"]["Coefficient"]}
                        majoEnfant={"-"}
                        pension={InfosPension?.InfosRetraite["RsiArtisan"]["General"]["PensionApres97"]}
                      />
                    ) : (
                      ""
                    )}
                  </>
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("RCI") && InfosPension?.InfosRetraite["RCI"]["General"]["TotalPoint"] > 0 && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"RCI"}
                    MiseEnForme={""}
                    points={InfosPension?.InfosRetraite["RCI"]["General"]["TotalPoint"]}
                    valeurPoint={InfosPension?.InfosRetraite["RCI"]["General"]["ValeurPoint"]}
                    pensionTheo={InfosPension?.InfosRetraite["RCI"]["General"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["RCI"]["General"]["Coefficient"]}
                    majoEnfant={"-"}
                    pension={InfosPension?.InfosRetraite["RCI"]["General"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Ravgdt") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"RAVGDT"}
                    MiseEnForme={""}
                    points={InfosPension?.InfosRetraite["Ravgdt"]["General"]["TotalPoint"]}
                    valeurPoint={InfosPension?.InfosRetraite["Ravgdt"]["General"]["ValeurPoint"]}
                    pensionTheo={InfosPension?.InfosRetraite["Ravgdt"]["General"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["Ravgdt"]["General"]["Coefficient"]}
                    majoEnfant={"-"}
                    pension={InfosPension?.InfosRetraite["Ravgdt"]["General"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Cipav") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"CIPAV"}
                    MiseEnForme={""}
                    points={InfosPension?.InfosRetraite["Cipav"]["General"]["TotalPoint"]}
                    valeurPoint={InfosPension?.InfosRetraite["Cipav"]["General"]["ValeurPoint"]}
                    pensionTheo={InfosPension?.InfosRetraite["Cipav"]["General"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["Cipav"]["General"]["Coefficient"]}
                    majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                    pension={InfosPension?.InfosRetraite["Cipav"]["General"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Carpv") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"CARPV"}
                    MiseEnForme={""}
                    points={InfosPension?.InfosRetraite["Carpv"]["General"]["TotalPoint"]}
                    valeurPoint={InfosPension?.InfosRetraite["Carpv"]["General"]["ValeurPoint"]}
                    pensionTheo={InfosPension?.InfosRetraite["Carpv"]["General"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["Carpv"]["General"]["Coefficient"]}
                    majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                    pension={InfosPension?.InfosRetraite["Carpv"]["General"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Cavec") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"CAVEC"}
                    MiseEnForme={""}
                    points={InfosPension?.InfosRetraite["Cavec"]["General"]["TotalPoint"]}
                    valeurPoint={InfosPension?.InfosRetraite["Cavec"]["General"]["ValeurPoint"]}
                    pensionTheo={InfosPension?.InfosRetraite["Cavec"]["General"]["PensionTheorique"]}
                    coeff={
                      InfosPension?.InfosRetraite["Cavec"]["General"]["MontantMajo"] === 0
                        ? InfosPension?.InfosRetraite["Cavec"]["General"]["CoeffMino"]
                        : Number(InfosPension?.InfosRetraite["Cavec"]["General"]["Pension"] / InfosPension?.InfosRetraite["Cavec"]["General"]["PensionTheorique"]).toFixed(2)
                    }
                    majoEnfant={"-"}
                    pension={InfosPension?.InfosRetraite["Cavec"]["General"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Cavamac") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"CAVAMAC"}
                    MiseEnForme={""}
                    points={InfosPension?.InfosRetraite["Cavamac"]["General"]["TotalPoint"]}
                    valeurPoint={InfosPension?.InfosRetraite["Cavamac"]["General"]["ValeurPoint"]}
                    pensionTheo={InfosPension?.InfosRetraite["Cavamac"]["General"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["Cavamac"]["General"]["Coefficient"]}
                    majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                    pension={InfosPension?.InfosRetraite["Cavamac"]["General"]["Pension"]}
                  />
                )}

                {InfosPension?.InfosRetraite?.hasOwnProperty("Crn") && InfosPension?.InfosRetraite["Crn"]["General"]["TotalPointSectionB"] > 0 && (
                  <>
                    <FormatLignePension
                      keyId={index++}
                      caisse={"CRN section B"}
                      MiseEnForme={""}
                      points={InfosPension?.InfosRetraite["Crn"]["General"]["TotalPointSectionB"]}
                      valeurPoint={InfosPension?.InfosRetraite["Crn"]["General"]["ValeurPointSectionB"]}
                      pensionTheo={InfosPension?.InfosRetraite["Crn"]["General"]["PensionTheoriqueSectionB"]}
                      coeff={InfosPension?.InfosRetraite["Crn"]["General"]["Coefficient"]}
                      majoEnfant={"-"}
                      pension={InfosPension?.InfosRetraite["Crn"]["General"]["PensionSectionB"]}
                    />
                    <FormatLignePension
                      keyId={index++}
                      caisse={"CRN section C"}
                      MiseEnForme={""}
                      points={InfosPension?.InfosRetraite["Crn"]["General"]["TotalPointSectionC"]}
                      valeurPoint={InfosPension?.InfosRetraite["Crn"]["General"]["ValeurPointSectionC"]}
                      pensionTheo={InfosPension?.InfosRetraite["Crn"]["General"]["PensionTheoriqueSectionC"]}
                      coeff={InfosPension?.InfosRetraite["Crn"]["General"]["Coefficient"]}
                      majoEnfant={"-"}
                      pension={InfosPension?.InfosRetraite["Crn"]["General"]["PensionSectionC"]}
                    />
                  </>
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Carpimko") && InfosPension?.InfosRetraite["Carpimko"]["General"]["TotalPoint"] > 0 && (
                  <>
                    <FormatLignePension
                      keyId={index++}
                      caisse={"CARPIMKO"}
                      MiseEnForme={""}
                      points={InfosPension?.InfosRetraite["Carpimko"]["General"]["TotalPoint"]}
                      valeurPoint={InfosPension?.InfosRetraite["Carpimko"]["General"]["ValeurPoint"]}
                      pensionTheo={InfosPension?.InfosRetraite["Carpimko"]["General"]["PensionTheorique"]}
                      coeff={InfosPension?.InfosRetraite["Carpimko"]["General"]["Coefficient"]}
                      majoEnfant={"-"}
                      pension={InfosPension?.InfosRetraite["Carpimko"]["General"]["Pension"]}
                    />
                  </>
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Carmf") && InfosPension?.InfosRetraite["Carmf"]["General"]["TotalPoint"] > 0 && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"CARMF"}
                    MiseEnForme={""}
                    points={InfosPension?.InfosRetraite["Carmf"]["General"]["TotalPoint"]}
                    valeurPoint={InfosPension?.InfosRetraite["Carmf"]["General"]["ValeurPoint"]}
                    pensionTheo={InfosPension?.InfosRetraite["Carmf"]["General"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["Carmf"]["General"]["Coefficient"]}
                    majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                    pension={InfosPension?.InfosRetraite["Carmf"]["General"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Carcdsf") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"CARCD"}
                    MiseEnForme={""}
                    points={InfosPension?.InfosRetraite["Carcdsf"]["General"]["TotalPoint"]}
                    valeurPoint={InfosPension?.InfosRetraite["Carcdsf"]["General"]["ValeurPoint"]}
                    pensionTheo={InfosPension?.InfosRetraite["Carcdsf"]["General"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["Carcdsf"]["General"]["Coefficient"]}
                    majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                    pension={InfosPension?.InfosRetraite["Carcdsf"]["General"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Carcdsf2") && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"CARSF"}
                    MiseEnForme={""}
                    points={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["TotalPoint"]}
                    valeurPoint={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["ValeurPoint"]}
                    pensionTheo={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["Coefficient"]}
                    majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                    pension={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Cavom") && InfosPension?.InfosRetraite["Cavom"]["General"]["TotalPoint"] > 0 && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"CAVOM"}
                    MiseEnForme={""}
                    points={InfosPension?.InfosRetraite["Cavom"]["General"]["TotalPoint"]}
                    valeurPoint={InfosPension?.InfosRetraite["Cavom"]["General"]["ValeurPoint"]}
                    pensionTheo={InfosPension?.InfosRetraite["Cavom"]["General"]["PensionTheorique"]}
                    coeff={InfosPension?.InfosRetraite["Cavom"]["General"]["Coefficient"]}
                    majoEnfant={"-"}
                    pension={InfosPension?.InfosRetraite["Cavom"]["General"]["Pension"]}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Cavp") && (
                  <>
                    <FormatLignePension
                      keyId={index++}
                      caisse={"CAVP par répartition"}
                      MiseEnForme={""}
                      points={"-"}
                      valeurPoint={"-"}
                      pensionTheo={InfosPension?.InfosRetraite["Cavp"]["General"]["PensionRepartTheorique"]}
                      coeff={InfosPension?.InfosRetraite["Cavp"]["General"]["Coefficient"]}
                      majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                      pension={InfosPension?.InfosRetraite["Cavp"]["General"]["PensionRepart"]}
                    />
                    <FormatLignePension
                      keyId={index++}
                      caisse={"CAVP par capitalisation"}
                      MiseEnForme={""}
                      points={"-"}
                      valeurPoint={"-"}
                      pensionTheo={"-"}
                      coeff={"-"}
                      majoEnfant={"-"}
                      pension={InfosPension?.InfosRetraite["Cavp"]["General"]["PensionCapi"]}
                    />
                  </>
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Rafp") && (
                  <>
                    {InfosPension?.InfosRetraite["Rafp"]["General"]["TransformationCapitalRafp"] === "Non" ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"RAFP"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Rafp"]["General"]["TotalPoint"]}
                        valeurPoint={InfosPension?.InfosRetraite["Rafp"]["General"]["ValeurPoint"]}
                        pensionTheo={InfosPension?.InfosRetraite["Rafp"]["General"]["PensionTheorique"]}
                        coeff={InfosPension?.InfosRetraite["Rafp"]["General"]["Coefficient"]}
                        majoEnfant={"-"}
                        pension={InfosPension?.InfosRetraite["Rafp"]["General"]["Pension"]}
                      />
                    ) : (
                      ""
                    )}
                  </>
                )}
                {InfosPension.InfosRetraite?.hasOwnProperty("Cnbf") && (
                  <>
                    {InfosPension.InfosRetraite["Cnbf"]["General"]["TotalPoint"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CNBF"}
                        MiseEnForme={""}
                        points={InfosPension.InfosRetraite["Cnbf"]["General"]["TotalPoint"]}
                        valeurPoint={InfosPension.InfosRetraite["Cnbf"]["General"]["ValeurPoint"]}
                        pensionTheo={InfosPension.InfosRetraite["Cnbf"]["General"]["PensionTheoriqueComp"]}
                        coeff={InfosPension.InfosRetraite["Cnbf"]["General"]["CoeffMino"]}
                        majoEnfant={InfosPension.InfosRetraite["Cnbf"]["General"]["CoeffMajoEnfant"] > 0 ? "10%" : "-"}
                        pension={InfosPension.InfosRetraite["Cnbf"]["General"]["PensionComp"]}
                      />
                    ) : (
                      ""
                    )}
                  </>
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Msa") && (
                  <>
                    {InfosPension?.InfosRetraite["Msa"]["General"]["TotalPointComp"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"MSA RCO"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Msa"]["General"]["TotalPointComp"]}
                        valeurPoint={InfosPension?.InfosRetraite["Msa"]["General"]["ValeurPointComp"]}
                        pensionTheo={InfosPension?.InfosRetraite["Msa"]["General"]["PensionTheoriqueComp"]}
                        coeff={InfosPension?.InfosRetraite["Msa"]["General"]["CoefficientComp"]}
                        majoEnfant={"-"}
                        pension={InfosPension?.InfosRetraite["Msa"]["General"]["PensionComp"]}
                      />
                    ) : (
                      ""
                    )}
                  </>
                )}
                <FormatLigneTotal keyId={index++} caisse={"Total régimes complémentaires"} pension={Math.max(0, InfosPension?.TotalPensionComplementaire)} />
                {InfosPension?.TotalPensionSupplementaire > 0 && (
                  <FormatLignePension
                    keyId={index++}
                    caisse={"Régimes supplémentaires"}
                    MiseEnForme={"detail-regime-categorie"}
                    points={""}
                    valeurPoint={""}
                    pensionTheo={""}
                    coeff={""}
                    majoEnfant={""}
                    pension={""}
                  />
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Carcdsf") && (
                  <>
                    {InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvTotalPointAvant1995"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CARCD ASV avant 1995"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvTotalPointAvant1995"]}
                        valeurPoint={InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvValeurPointAvant1995"]}
                        pensionTheo={InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvPensionTheoriqueAvant1995"]}
                        coeff={InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvCoefficient"]}
                        majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                        pension={InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvPensionAvant1995"]}
                      />
                    ) : (
                      ""
                    )}
                    {InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvTotalPoint19952005"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CARCD ASV entre 1995 et 2005"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvTotalPoint19952005"]}
                        valeurPoint={InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvValeurPoint19952005"]}
                        pensionTheo={InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvPensionTheorique19952005"]}
                        coeff={InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvCoefficient"]}
                        majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                        pension={InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvPension19952005"]}
                      />
                    ) : (
                      ""
                    )}
                    {InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvTotalPointApres2006"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CARCD ASV après 2005"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvTotalPointApres2006"]}
                        valeurPoint={InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvValeurPoint"]}
                        pensionTheo={InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvPensionTheorique"]}
                        coeff={InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvCoefficient"]}
                        majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                        pension={InfosPension?.InfosRetraite["Carcdsf"]["General"]["AsvPensionApres2006"]}
                      />
                    ) : (
                      ""
                    )}
                  </>
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Carcdsf2") && (
                  <>
                    {InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvTotalPointAvant1995"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CARSF ASV avant 1995"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvTotalPointAvant1995"]}
                        valeurPoint={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvValeurPointAvant1995"]}
                        pensionTheo={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvPensionTheoriqueAvant1995"]}
                        coeff={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvCoefficient"]}
                        majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                        pension={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvPensionAvant1995"]}
                      />
                    ) : (
                      ""
                    )}
                    {InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvTotalPoint19952005"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CARSF ASV entre 1995 et 2005"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvTotalPoint19952005"]}
                        valeurPoint={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvValeurPoint19952005"]}
                        pensionTheo={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvPensionTheorique19952005"]}
                        coeff={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvCoefficient"]}
                        majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                        pension={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvPension19952005"]}
                      />
                    ) : (
                      ""
                    )}
                    {InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvTotalPointApres2006"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CARSF ASV après 2005"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvTotalPointApres2006"]}
                        valeurPoint={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvValeurPoint"]}
                        pensionTheo={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvPensionTheorique"]}
                        coeff={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvCoefficient"]}
                        majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                        pension={InfosPension?.InfosRetraite["Carcdsf2"]["General"]["AsvPensionApres2006"]}
                      />
                    ) : (
                      ""
                    )}
                  </>
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Carmf") && (
                  <>
                    {InfosPension?.InfosRetraite["Carmf"]["General"]["TotalPointAsv"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CARMF ASV"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Carmf"]["General"]["TotalPointAsv"]}
                        valeurPoint={InfosPension?.InfosRetraite["Carmf"]["General"]["AsvValeurPoint"]}
                        pensionTheo={InfosPension?.InfosRetraite["Carmf"]["General"]["AsvPensionTheorique"]}
                        coeff={InfosPension?.InfosRetraite["Carmf"]["General"]["AsvCoefficient"]}
                        majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                        pension={InfosPension?.InfosRetraite["Carmf"]["General"]["AsvPension"]}
                      />
                    ) : (
                      ""
                    )}
                  </>
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Carpimko") && (
                  <>
                    {InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvTotalPoint19601975"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CARPIMKO ASV entre 1960 et 1975"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvTotalPoint19601975"]}
                        valeurPoint={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvValeurPoint19601975"]}
                        pensionTheo={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvPensionTheorique19601975"]}
                        coeff={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvCoefficient"]}
                        majoEnfant={"-"}
                        pension={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvPension19601975"]}
                      />
                    ) : (
                      ""
                    )}
                    {InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvTotalPoint19761987"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CARPIMKO ASV entre 1976 et 1987"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvTotalPoint19761987"]}
                        valeurPoint={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvValeurPoint19761987"]}
                        pensionTheo={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvPensionTheorique19761987"]}
                        coeff={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvCoefficient"]}
                        majoEnfant={"-"}
                        pension={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvPension19761987"]}
                      />
                    ) : (
                      ""
                    )}
                    {InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvTotalPoint19881997"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CARPIMKO ASV entre 1988 et 1997"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvTotalPoint19881997"]}
                        valeurPoint={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvValeurPoint19881997"]}
                        pensionTheo={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvPensionTheorique19881997"]}
                        coeff={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvCoefficient"]}
                        majoEnfant={"-"}
                        pension={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvPension19881997"]}
                      />
                    ) : (
                      ""
                    )}
                    {InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvTotalPoint19982005"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CARPIMKO ASV entre 1998 et 2005"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvTotalPoint19982005"]}
                        valeurPoint={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvValeurPoint19982005"]}
                        pensionTheo={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvPensionTheorique19982005"]}
                        coeff={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvCoefficient"]}
                        majoEnfant={"-"}
                        pension={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvPension19982005"]}
                      />
                    ) : (
                      ""
                    )}
                    {InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvTotalPointApres2005"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CARPIMKO ASV après 2005"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvTotalPointApres2005"]}
                        valeurPoint={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvValeurPointApres2005"]}
                        pensionTheo={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvPensionTheoriqueApres2005"]}
                        coeff={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvCoefficient"]}
                        majoEnfant={"-"}
                        pension={InfosPension?.InfosRetraite["Carpimko"]["General"]["AsvPensionApres2005"]}
                      />
                    ) : (
                      ""
                    )}
                  </>
                )}
                {InfosPension?.InfosRetraite?.hasOwnProperty("Cavp") && (
                  <>
                    {InfosPension?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint19771981"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CAVP PCV entre 1977 et 1981"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint19771981"]}
                        valeurPoint={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvValeurPoint19771981"]}
                        pensionTheo={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvPensionTheorique19771981"]}
                        coeff={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvCoefficient"]}
                        majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                        pension={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvPension19771981"]}
                      />
                    ) : (
                      ""
                    )}
                    {InfosPension?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint19821986"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CAVP PCV entre 1982 et 1986"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint19821986"]}
                        valeurPoint={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvValeurPoint19821986"]}
                        pensionTheo={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvPensionTheorique19821986"]}
                        coeff={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvCoefficient"]}
                        majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                        pension={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvPension19821986"]}
                      />
                    ) : (
                      ""
                    )}
                    {InfosPension?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint19871991"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CAVP PCV entre 1987 et 1991"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint19871991"]}
                        valeurPoint={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvValeurPoint19871991"]}
                        pensionTheo={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvPensionTheorique19871991"]}
                        coeff={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvCoefficient"]}
                        majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                        pension={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvPension19871991"]}
                      />
                    ) : (
                      ""
                    )}
                    {InfosPension?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint19921996"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CAVP PCV entre 1992 et 1996"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint19921996"]}
                        valeurPoint={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvValeurPoint19921996"]}
                        pensionTheo={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvPensionTheorique19921996"]}
                        coeff={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvCoefficient"]}
                        majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                        pension={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvPension19921996"]}
                      />
                    ) : (
                      ""
                    )}
                    {InfosPension?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint19972001"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CAVP PCV entre 1997 et 2001"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint19972001"]}
                        valeurPoint={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvValeurPoint19972001"]}
                        pensionTheo={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvPensionTheorique19972001"]}
                        coeff={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvCoefficient"]}
                        majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                        pension={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvPension19972001"]}
                      />
                    ) : (
                      ""
                    )}
                    {InfosPension?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint20022005"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CAVP PCV entre 2002 et 2005"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint20022005"]}
                        valeurPoint={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvValeurPoint20022005"]}
                        pensionTheo={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvPensionTheorique20022005"]}
                        coeff={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvCoefficient"]}
                        majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                        pension={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvPension20022005"]}
                      />
                    ) : (
                      ""
                    )}
                    {InfosPension?.InfosRetraite["Cavp"]["General"]["AsvTotalPointAPartir2024"] > 0 ? (
                      <FormatLignePension
                        keyId={index++}
                        caisse={"CAVP PCV après 2005"}
                        MiseEnForme={""}
                        points={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvTotalPointAPartir2024"]}
                        valeurPoint={InfosPension?.InfosRetraite["Cavp"]["General"]["ValeurPointAsv"]}
                        pensionTheo={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvPensionTheorique"]}
                        coeff={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvCoefficient"]}
                        majoEnfant={nbEnfant >= 3 ? "10%" : "-"}
                        pension={InfosPension?.InfosRetraite["Cavp"]["General"]["AsvPensionAPartir2023"]}
                      />
                    ) : (
                      ""
                    )}
                  </>
                )}
                {InfosPension?.TotalPensionSupplementaire > 0 && (
                  <FormatLigneTotal keyId={index++} caisse={"Total régimes supplémentaires"} pension={Math.max(0, InfosPension?.TotalPensionSupplementaire)} />
                )}
                {Array.isArray(context.state["TabAutresPensions" + ClientConjoint]) && (
                  <>
                    <FormatLignePension
                      keyId={index++}
                      caisse={"Autres pensions"}
                      MiseEnForme={"detail-regime-categorie"}
                      points={""}
                      valeurPoint={""}
                      pensionTheo={""}
                      coeff={""}
                      majoEnfant={""}
                      pension={""}
                    />
                    {context.state["TabAutresPensions" + ClientConjoint].map((pensionAutre) => (
                      <FormatLignePension
                        keyId={index++}
                        caisse={pensionAutre["libelle"]}
                        MiseEnForme={""}
                        points={"-"}
                        valeurPoint={"-"}
                        pensionTheo={"-"}
                        coeff={"-"}
                        majoEnfant={"-"}
                        pension={pensionAutre?.pensions[0]?.pensionBrute}
                      />
                    ))}
                      <FormatLigneTotal keyId={index++} caisse={"Total autres pensions"} pension={Math.max(0, InfosPension?.TotalAutresPensionsBrute)} />
                  </>
                )}
                <FormatLigneTotal2 keyId={index++} caisse={"Pension brute"} pension={Math.max(0, InfosPension?.TotalPensionBrute)} />
                <FormatLigneTotal2 keyId={index++} caisse={"Pension nette de prélèvements sociaux"} pension={Math.max(0, InfosPension?.TotalPensionNette)} />
              </div>
            </div>
          </Row>
        </Column>
      </CardBox>
    </Column>
  );
};

export default DetailPension;

//    <FormatLignePension
//   keyId={index++}
//   caisse={"RSI Commerçant"}
//   points={data[1]["General"]["TotalPoint"]}
//   valeurPoint={data[1]["General"]["ValeurPoint"]}
//   pensionTheo={data[1]["General"]["PensionTheorique"]}
//   coeff={data[1]["General"]["Coefficient"]}
//   majoEnfant={"-"}
//   pension={data[1]["General"]["Pension"]}
// />
